/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Dentistry14Inputs */

const en__field_enum_study_dentistry14 = /** @type {(inputs: _Field_Enum_Study_Dentistry14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dentistry`)
};

const de__field_enum_study_dentistry14 = /** @type {(inputs: _Field_Enum_Study_Dentistry14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahnmedizin`)
};

/**
* | output |
* | --- |
* | "Dentistry" |
*
* @param {_Field_Enum_Study_Dentistry14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_dentistry14 = /** @type {((inputs?: _Field_Enum_Study_Dentistry14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Dentistry14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_dentistry14(inputs)
	return de__field_enum_study_dentistry14(inputs)
});
export { _field_enum_study_dentistry14 as "_field_enum_STUDY_DENTISTRY" }